import React from 'react';

import { FloatingContainer } from './styles';

export interface Props {
  id?: string;
  className?: string;
  zIndex?: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const FloatingButton = (props: Props) => (
  <FloatingContainer {...props}>
    <img src="/corporate/images/floating_button.svg" alt="rightIcon" />
  </FloatingContainer>
);

export default FloatingButton;
